import type { Dispatch } from 'react';
import { createContext } from 'react';

import type {
  OrgConstructionDescriptions,
  OrgInsuranceDescriptions,
} from '../validations/validations';

type OnboardingFormSharedState = {
  email?: string;
  password?: string;
  orgType?: string;
  orgName?: string;
  orgDescription?: (OrgConstructionDescriptions | OrgInsuranceDescriptions)[];
  customDescription?: string;
  orgUsage?: { min?: number; max?: number };
};

type Payload = Partial<OnboardingFormSharedState>;

export const OnboardingContext = createContext<
  [OnboardingFormSharedState, Dispatch<Payload>]
>([{}, () => ({})]);

export const onboardingFormReducer = (
  state: OnboardingFormSharedState,
  payload: Payload,
) => {
  if (payload) {
    return { ...state, ...payload };
  }

  return state;
};
